<p [id]="id"
  class="common__ellipsis-100"
  matTooltip="{{isDeleted?text +' ('+ ('common.inactive-user' | afTranslate)+')':text}}"
  [matTooltipPosition]="placement"
  [matTooltipClass]="placement"
  [matTooltipDisabled]="!showTooltip()">
  <span [id]="'span-'+id">{{text}}</span>
</p>
